import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/tlAccounts/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/tlAccounts/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/tlAccounts/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/tlAccounts/delete',
    method: 'post',
    data
  })
}

